/**
 * Store Echange Questions
 */
export default {
    getters: {
        optionsStatutQuestion: () => {
            return [
                { value: 10, label: 'Nouveau, en attente de traitement' },
                { value: 20, label: 'Incapacité de répondre, à rappeler' },
                { value: 30, label: 'En attente information client, à rappeler' },
                { value: 40, label: 'Nouvelle information, à traiter par Inelys' },
                { value: 50, label: 'Réponse fournie avec succès' }
            ]
        }
    }
}
